// extracted by mini-css-extract-plugin
export default {"extras_dropdown":"ExtrasMenu_extras_dropdown__cfA5U"};